window.SiteReady(($) => {

  console.log('Init Block: Content Swap');

  let $blocks = $('.js-content_swap');

  $blocks.each((index, el) => {
    let $block = $(el);
    let $select = $block.find('.js-content_swap_select');
    let $target = $block.find('.js-content_swap_target');
    let items = $block.data('items');

    let param = $block.data('query-param');
    let params = new URLSearchParams(window.location.search);

    $select.on('change', (e) => {
      let index = $select.prop('selectedIndex');

      $target.html(items[index].content);
    });

    if (param && params.get(param)) {
      $select.find('option:contains(' + params.get(param) + ')').prop('selected', true);
      $select.trigger('change');
    }
  });;

});